import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.element.addEventListener("load", (event) => {
      this.resize()
    });
  }
  
  resize() {
    const innerDoc = this.element.contentDocument || this.element.contentWindow.document
    const innerBody = innerDoc.body
    const innerHtml = innerDoc.documentElement
    const innerHeight = Math.max( innerBody.scrollHeight, innerBody.offsetHeight, innerHtml.clientHeight, innerHtml.scrollHeight, innerHtml.offsetHeight )
    return this.element.height = innerHeight
  }
}